import { Avatar } from "@material-ui/core";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import "../../App.css";
import CommonUtil from "../../Util/CommonUtils";
import { ReactComponent as ForceCheckOut } from "../../assets/USA_Images/dashboard_icons/Force_Checkout.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import InvitationFilterFromReport from "../../components/InvitationFilterFromReport";
import ProfileContext from "../../components/ProfileContext";
import Toast from "../../components/ToastContainer/CustomToast";
import CustomStyleStatus from "../../components/statusStyleFormat/statusStyleFormat";
import { exportInvitationVisitors } from "../../services/Invitations/ExportService";
import { listInvitations } from "../../slices/Invitations/InvitationsSlice";
import { forceUpdate } from "../../slices/PinNumber/PinNumberSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import BlacklistVisitorForm from "../BlacklistVisitors/BlacklistVisitorForm";
import ManualCheckout from "../DashBoard/ManualCheckout";
import BlockVisitorIcon from "../Invitations/BlockVisitorIcon";
import ExportDialog from "./ExportDialog";
import ReportPageViewProfile from "./ReportPageViewProfile";
import TransactionHistory from "./TransactionHistory";

export default function InvitationReport() {
  const [clear, setClear] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const [openBlacklistVisitor, setOpenBlacklistVisitor] = useState(false);
  const [blacklistId, setBlacklistId] = useState();
  const [del, setDel] = useState(false);
  const [pageSize, setPageSize] = useState(0);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [loading, setLoading] = useState(true);
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [fileFormat, setFileFormat] = useState("1");
  const [noOfRecords, setNoOfRecords] = useState("0");
  const [inputValue, setInputValue] = useState("");
  const [toInputValue, setToInputValue] = useState("");
  const [isLivePhoto, setIsLivePhoto] = useState(false);
  const [isSignature, setIsSignature] = useState(false);
  const [closemodel, setClosemodel] = useState(false);
  const [visitorFirstName, setVisitorFirstName] = useState("");
  const [visitorLastName, setVisitorLastName] = useState("");
  const { visitorEvents, setVisitorEvents } = useContext(ProfileContext);
  const [selectedData, setSelectedData] = useState();
  const [openManualCheckOut, setOpenManualCheckOut] = useState(false);
  const [visitorName, setVisitorName] = useState();

  const status = [
    "SCHEDULED",
    "CONFIRMED",
    "APPROVED",
    "CHECKED_IN",
    "CHECKED_OUT",
    "CANCELLED",
    "REJECTED",
    "MISSED",
    "COMPLETED",
    "INITIATED_FOR_BLOCKED",
    "BLOCKED",
    "TIME_EXPIRED",
  ];

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  var today = new Date();
  var endDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T23:59:59";
  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T00:00";

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const [filter, setFilter] = React.useState({
    status: [
      "SCHEDULED",
      "CONFIRMED",
      "APPROVED",
      "CHECKED_IN",
      "CHECKED_OUT",
      "CANCELLED",
      "INITIATED_FOR_BLOCKED",
      "BLOCKED",
      "REJECTED",
      "MISSED",
      "COMPLETED",
      "LOGGED",
      "TIME_EXPIRED",
    ],
    visitorTypeId: "",
    siteId: "",
    scheduledStartDate: "",
    scheduledEndDate: "",
    visitMode: ["INVITATION"],
    firstName: "",
    lastName: "",
    isPagable: true,
  });

  const defaultFilter = {
    status: [
      "SCHEDULED",
      "CONFIRMED",
      "APPROVED",
      "CHECKED_IN",
      "CHECKED_OUT",
      "CANCELLED",
      "INITIATED_FOR_BLOCKED",
      "BLOCKED",
      "REJECTED",
      "MISSED",
      "COMPLETED",
      "LOGGED",
      "TIME_EXPIRED",
    ],
    visitorTypeId: "",
    siteId: "",
    scheduledStartDate: "",
    scheduledEndDate: "",
    visitMode: ["INVITATION"],
    firstName: "",
    lastName: "",
    isPagable: true,
  };

  const handleChange = (newPage, size) => {
    setLoading(true);
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleOpen = () => {
    setOpen(true);
  };

  const resetFilter = () => {
    setLoading(true);
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const loadData = (filter, paging) => {
    dispatch(listInvitations(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          setLoading(false);
          setPageSize(data.data.pageSize);
          setTotalRecords(data.data.totalCount);
          setRows(data.data.visits);
          setPage(data.data.curPage);
          setTotalPages(data.data.totalPages);
        } else {
          setRows([]);
        }
      })
      .catch((er) => {});
  };

  const handleFilter = (data) => {
    setLoading(true);
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      siteId: data.siteId,
      visitorTypeId: data.visitorTypeId,
      visitMode: data.visitMode,
      scheduledStartDate: CommonUtil.formatToUtc(data.scheduledStartDate),
      scheduledEndDate: CommonUtil.formatToUtc(data.scheduledEndDate),
      firstName: data.firstName,
      lastName: data.lastName,
      status: data.status,
    });
  };

  const handleDatePickerFilter = (sdate, edate) => {
    setPaging({ ...paging, page: 1 });
    setFilter({
      scheduledStartDate: sdate,
      scheduledEndDate: edate,
    });
  };

  useEffect(() => {
    if (del === true && parseInt(pageSize) !== 1) {
      loadData(page, rowsPerPage);
      setDel(false);
    } else {
      if (del === true) {
        loadData(page - 1, rowsPerPage);
        setDel(false);
      }
    }
  }, [del]);

  const totalduration = (params) => {
    const start = moment(params.row.checkIn);
    const end = moment(params.row.checkOut);
    const duration = moment.duration(Math.abs(end.diff(start)));
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    const formattedDuration = `${hours
      .toString()
      .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
    return formattedDuration;
  };

  const handleBlacklistVisit = (params) => {
    setOpenBlacklistVisitor(!openBlacklistVisitor);
    setBlacklistId(params.row.id);
    setVisitorFirstName(params.row.visitor.firstName);
    setVisitorLastName(params.row.visitor.lastName);
    setDiaLogBoxBlur(true);
  };

  const getStatus = (params) => {
    if (
      params.row.status === "BLOCKED" ||
      params.row.status === "INITIATED_FOR_BLOCKED"
    ) {
      return true;
    }
  };
  const handleFileFormatChange = (event) => {
    setFileFormat(event.target.value);
  };

  const handleDataRecordsChange = (event) => {
    setNoOfRecords(event.target.value);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setInputValue(value);
    }
  };

  const handleToInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setToInputValue(value);
    }
  };

  const handleCheckBoxLivePhoto = (event) => {
    setIsLivePhoto(event.target.checked);
  };
  const handleCheckBoxSignature = (event) => {
    setIsSignature(event.target.checked);
  };

  const handleInvitationExport = (data) => {
    if (fileFormat == "2") {
      setIsLivePhoto(false);
      setIsSignature(false);
    }
    var searchParam = "";
    if (
      filter.firstName !== undefined &&
      !CommonUtil.isEmptyString(filter.firstName)
    ) {
      searchParam += "&firstName=" + encodeURIComponent(filter.firstName);
    }
    if (
      filter.lastName !== undefined &&
      !CommonUtil.isEmptyString(filter.lastName)
    ) {
      searchParam += "&lastName=" + encodeURIComponent(filter.lastName);
    }
    if (
      filter.scheduledStartDate !== undefined &&
      !CommonUtil.isEmptyString(filter.scheduledStartDate)
    ) {
      searchParam += "&scheduledStartDate=" + filter.scheduledStartDate;
    }
    if (
      filter.scheduledEndDate !== undefined &&
      !CommonUtil.isEmptyString(filter.scheduledEndDate)
    ) {
      searchParam += "&scheduledEndDate=" + filter.scheduledEndDate;
    }
    if (
      filter.visitorTypeId !== undefined &&
      !CommonUtil.isEmptyString(filter.visitorTypeId)
    ) {
      searchParam += "&visitorTypeId=" + filter.visitorTypeId;
    }
    if (
      filter.siteId !== undefined &&
      !CommonUtil.isEmptyString(filter.siteId)
    ) {
      searchParam += "&siteId=" + filter.siteId;
    }
    if (fileFormat !== "2") {
      searchParam += "&isLivePhoto=" + isLivePhoto;
      searchParam += "&isSignature=" + isSignature;
    } else {
      searchParam += "&isLivePhoto=" + false;
      searchParam += "&isSignature=" + false;
    }
    const stats = {
      page: 1,
      rowsPerPage: 1000,
      status: [
        "SCHEDULED",
        "CONFIRMED",
        "APPROVED",
        "CHECKED_IN",
        "CHECKED_OUT",
        "CANCELLED",
        "INITIATED_FOR_BLOCKED",
        "BLOCKED",
        "REJECTED",
        "MISSED",
        "COMPLETED",
        "LOGGED",
        "TIME_EXPIRED",
      ],
      fileType: fileFormat,
      from: inputValue === "" ? "0" : inputValue,
      to: toInputValue === "" ? "0" : toInputValue,
    };

    dispatch(exportInvitationVisitors(onSuccess, onFailure, stats, searchParam))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          onSuccess();
        } else {
          onFailure();
        }
      })
      .catch((er) => {});
  };

  const onSuccess = () => {
    setClosemodel(true);
    return Toast(t("EXPORTSUCC001"), "success");
  };

  const onFailure = () => {
    Toast(t("COMMON000"), "error");
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 18) {
      return text.substring(0, 18) + "...";
    } else {
      return text;
    }
  };

  const [date, setDate] = useState();

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy HH:mm";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy HH:mm";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  const renderCellScheduledStartDate = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.scheduledStartDate),
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : date === "yyyy-MM-dd HH:mm"
        ? "YYYY-MM-DD HH:mm"
        : "",
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const renderCellCheckIn = (date) => (params) => {
    const row = params.row || {};
    const checkIn = row.checkIn || null;
    if (!checkIn) return <span className="table-cell-trucate"></span>;
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(checkIn),
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : date === "yyyy-MM-dd HH:mm"
        ? "YYYY-MM-DD HH:mm"
        : "",
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const renderCellCheckOut = (date) => (params) => {
    const row = params.row || {};
    const checkOut = row.checkOut || null;
    if (!checkOut) return <span className="table-cell-trucate"></span>;
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(checkOut),
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : date === "yyyy-MM-dd HH:mm"
        ? "YYYY-MM-DD HH:mm"
        : "",
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { firstName, lastName, profilePhotoURL } = params.row.visitor;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };
    // Get initials
    const initials = `${firstName?.charAt(0) || ""}${lastName?.charAt(0) ||
      ""}`;
    const bgColor = !profilePhotoURL ? getAvatarColor(initials) : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = profilePhotoURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            onContextMenu={(e) => e.preventDefault()}
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            onContextMenu={(e) => e.preventDefault()}
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };

  const columns = React.useMemo(
    () => [
      {
        field: "visitor.profile",
        headerName: "",
        sortable: false,
        width: 10,
        renderCell: (params) => {
          return ZoomHandaler(params);
        },
      },
      {
        field: "visitor.firstName",
        headerName: t("COMMON014"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) =>
          params.row.visitor.lastName !== null
            ? params.row.visitor.firstName + " " + params.row.visitor.lastName
            : params.row.visitor.firstName,
        renderCell: (params) => (
          <Tooltip
            title={` ${
              params.row.visitor.lastName !== null
                ? params.row.visitor.firstName +
                  " " +
                  params.row.visitor.lastName
                : params.row.visitor.firstName
            }`}
            placement="bottom-start"
          >
            <span>
              {handleTextOverflow(
                params.row.visitor.lastName !== null
                  ? params.row.visitor.firstName +
                      " " +
                      params.row.visitor.lastName
                  : params.row.visitor.firstName,
              )}
            </span>
          </Tooltip>
        ),
      },

      {
        field: "purpose",
        headerName: t("Purpose"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) =>
          params.row.visitor.purposeType !== null
            ? params.row.purposeType?.name
            : "",
        renderCell: (params) => (
          <Tooltip
            title={` ${
              params.row.visitor.purposeType !== null
                ? params.row.purposeType?.name
                : ""
            }`}
            placement="bottom-start"
          >
            <span>
              {handleTextOverflow(
                params.row.visitor.purposeType !== null
                  ? params.row.purposeType?.name
                  : "",
              )}
            </span>
          </Tooltip>
        ),
      },

      {
        field: "scheduledStartDate",
        headerName: t("INVITEDATELBL"),
        flex: 1,
        minWidth: 160,
        renderCell: renderCellScheduledStartDate(
          formatDate(companySettings.dateFormat),
        ),
      },
      {
        field: "checkIn",
        headerName: t("Check In"),
        flex: 1,
        minWidth: 160,
        renderCell: renderCellCheckIn(formatDate(companySettings.dateFormat)),
      },

      {
        field: "checkOut",
        headerName: t("Check Out"),
        flex: 1,
        minWidth: 160,
        renderCell: renderCellCheckOut(formatDate(companySettings.dateFormat)),
      },

      {
        field: "duration",
        headerName: "Total Duration (HH:MM)",
        flex: 1,
        minWidth: 190,
        valueGetter: (params) =>
          params.row.checkOut && params.row.checkIn
            ? totalduration(params)
            : "",
      },

      {
        field: "status",
        headerName: t("COMMON001"),
        flex: 1,
        minWidth: 190,
        renderCell: (params) => {
          return <CustomStyleStatus row={params.row.status} icon={false} />;
        },
      },

      {
        field: "Transaction History",
        headerName: "Transaction History",
        type: "actions",
        flex: 1,
        minWidth: 160,
        headerAlign: "left",
        align: "left",
        getActions: (params) => [
          // <GridActionsCellItem
          // icon={
          <TransactionHistory
            rowData={params.row}
            date={formatDate(companySettings.dateFormat)}
          />,
          // }
          // label="Transaction History"
          // />,
        ],
      },

      {
        field: "Actions",
        headerName: t("ACTION"),
        type: "actions",
        flex: 1,
        minWidth: 130,
        align: "left",
        headerAlign: "left",
        getActions: (params) => [
          <ReportPageViewProfile rowData={params.row} />,
          <Box
            sx={{
              opacity: getStatus(params) ? 0.4 : 2, // Dim when disabled
              cursor: getStatus(params) ? "not-allowed" : "pointer",
            }}
            onClick={() => {
              if (!getStatus(params)) {
                // only trigger if not disabled
                handleBlacklistVisit(params);
              }
            }}
          >
            <BlockVisitorIcon />
          </Box>,
          <Box>
            {!visitorEvents && (
              <Tooltip title={"Checkout"}>
                <IconButton disabled={!isForceCheckoutEnabled(params.row)}>
                  <ForceCheckOut
                    onClick={() => handleManualCheckOut(params.row)}
                  />
                </IconButton>
              </Tooltip>
            )}
          </Box>,
        ],
      },
    ],
    [companySettings.dateFormat],
  );

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const handleManualCheckOut = (params) => {
    setVisitorName(
      params.visitor.firstName + " " + (params.visitor?.lastName || ""),
    );
    setSelectedData(params);
    setOpenManualCheckOut(!openManualCheckOut);
  };

  const handlestatusUpdate = () => {
    let payload = {
      id: selectedData.id,
      name: selectedData.visitor?.lastName
        ? selectedData.visitor?.firstName + " " + selectedData.visitor?.lastName
        : selectedData.visitor?.firstName,
    };
    dispatch(forceUpdate(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4054") {
          Toast(res.message, "success");
          setOpenManualCheckOut(!openManualCheckOut);
          loadData(filter, paging);
          // loadDashBoard();
          // loadHaventCheckedOutData(1, rowsPerPage);
          return;
        } else {
          Toast(res.message, "error");
          return;
        }
      });
  };

  const isForceCheckoutEnabled = (row) => {
    const nowUTC = new Date().getTime();
    const finalUTC = new Date(row.finalCheckOutTime + "Z").getTime();
    return nowUTC > finalUTC && row.status === "TIME_EXPIRED";
  };

  return (
    <>
      {/*  */}
      <HeaderToolbar title={t("INVITATION001")} />
      <div>
        <Box
          display={"flex"}
          width={"100%"}
          flexDirection={"row-reverse"}
          alignItems={"center"}
          style={{ gap: "6px", padding: "10px 0px 12px 10px" }}
        >
          {clear && (
            <Box item>
              <Link
                href="#"
                underline="hover"
                className="line"
                style={{
                  opacity: "0.8",
                  color: "#E3393C",
                  fontSize: "14px",
                  underline: "hover",
                  display: "inline",
                }}
                onClick={resetFilter}
              >
                {t("CLEARFILTER")}
              </Link>
            </Box>
          )}

          <Box item>
            <ExportDialog
              rowsPerPage={rowsPerPage}
              applyFilter={(data) => handleInvitationExport(data)}
              date={date}
              totalRecords={totalRecords}
              nameTitle={"Export Invitation"}
              handleFileFormatChange={handleFileFormatChange}
              handleDataRecordsChange={handleDataRecordsChange}
              handleInputChange={handleInputChange}
              handleToInputChange={handleToInputChange}
              fileFormat={fileFormat}
              noOfRecords={noOfRecords}
              inputValue={inputValue}
              toInputValue={toInputValue}
              setFileFormat={setFileFormat}
              setNoOfRecords={setNoOfRecords}
              setInputValue={setInputValue}
              setToInputValue={setToInputValue}
              setIsLivePhoto={setIsLivePhoto}
              setIsSignature={setIsSignature}
              isLivePhoto={isLivePhoto}
              isSignature={isSignature}
              handleCheckBoxLivePhoto={handleCheckBoxLivePhoto}
              handleCheckBoxSignature={handleCheckBoxSignature}
              closemodel={closemodel}
              setClosemodel={setClosemodel}
            />
          </Box>

          <Tooltip title={t("COMMON002")}>
            <Box className="refreshIcon">
              <RefreshIcon onClick={() => loadData(filter, paging)} />
            </Box>
          </Tooltip>
          <Box item>
            <InvitationFilterFromReport
              rowsPerPage={rowsPerPage}
              selectedObject={filter.visitMode}
              status={status}
              applyFilter={(data) => handleFilter(data)}
              date={formatDate(companySettings.dateFormat)}
            />
          </Box>
        </Box>
      </div>
      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {openBlacklistVisitor && (
        <BlacklistVisitorForm
          open={openBlacklistVisitor}
          handleClose={(data) => {
            setOpenBlacklistVisitor(data);
            setDiaLogBoxBlur(false);
            loadData(filter, paging);
          }}
          disable={() => setDel(true)}
          BlacklistVisitorId={blacklistId}
          module={"Report"}
          subModule={"Invitation"}
          blockListName={`${visitorFirstName}${
            visitorLastName ? " " + visitorLastName : ""
          }`}
        />
      )}

      {openManualCheckOut && (
        <ManualCheckout
          onClose={() => {
            setOpenManualCheckOut(!openManualCheckOut);
            loadData(filter, paging);
          }}
          onSubmit={handlestatusUpdate}
          open={openManualCheckOut}
          visitorName={visitorName}
        />
      )}
    </>
  );
}
